import {updateGridRowData} from "../../grid/update";
import {switchToDetail} from "../../grid/toolbar/detail";
import {loadDetailContent, reloadGridDetailContent} from "../../grid/detail";
import {getNaja} from "../../config";

export function gridFormSubmit() {
	$('body').on('click', 'button[ajax-grid-form-submit]', function (event) {
		var $el = $(this)
		var $form = $el.closest("form")

		if ($form.length == 0) {
			$form = $el.closest("[data-role=window] form")
		}

		if ($form[0].checkValidity()) {
			event.preventDefault()

			getNaja().makeRequest($form.attr('method'), $form.attr('action'), new FormData($form.get(0)), {gridForm: true}).then((payload) => {
				if (payload.result == true) {
					if (typeof $el.closest("[data-role=window]").data("kendoWindow") !== 'undefined') {
						$el.closest("[data-role=window]").data("kendoWindow").close()
					}

					staticNotification.success('Data úspěšně uložena.');

					if(payload.hasOwnProperty('loadDetail')) {
						switchToDetail(false)
						loadDetailContent(payload.loadDetail)
					}

					if ($form.attr('data-submit') !== 'no-grid-action') {
						if (typeof window.gridSettings.api !== 'undefined') {
							updateGridRowData(payload.model, false)
						}
					}

					if ($form.attr('data-submit') === 'load-detail') {
						switchToDetail(false)
						loadDetailContent(payload.model.id)
					}

					if ($form.attr('data-submit') === 'reload-detail') {
						reloadGridDetailContent()
					}
				} else {
					staticNotification.error(payload.errorMessage)
				}
			}).catch((error) => {
				console.log(error);
				staticNotification.error('Neočekávaná chyba, opakujte prosím akci později!')
			});
		} else {
			$('<input type="submit">')
				.hide()
				.appendTo($form)
				.trigger('click')
				.detach()
		}
	})

}